import { toast } from '../common/toast';

// Downed servers often fail CORS preflight with no Access-Control-Allow-Origin header.
// Browser/axios surface that as TypeError: Failed to fetch or Axios Network Error.
export const SERVER_UNREACHABLE = 'server_unreachable';
export const UNREACHABLE_SERVER_TOAST_OPTIONS = { autoClose: false };
export const UNREACHABLE_SERVICE_MESSAGE = 'The service may be temporarily unavailable. Please try again shortly.';
export const REDEPLOY_MESSAGE = 'No response, the server is likely being redeployed try again in a minute';

const FAILED_TO_FETCH = 'Failed to fetch';

export const isLikelyUnreachableError = (error) => {
  if (error?.code === SERVER_UNREACHABLE) return true;
  if (error?.code === 'ERR_NETWORK') return true;
  if (!error?.response && error?.message === 'Network Error') return true;
  if (error instanceof TypeError && error.message === FAILED_TO_FETCH) return true;
  return false;
};

export const getRequestFailureMessage = (error, { context, serviceLabel } = {}) => {
  const action = context || 'complete the request';

  if (error?.response?.status === 404) {
    return REDEPLOY_MESSAGE;
  }

  if (isLikelyUnreachableError(error)) {
    const target = serviceLabel || error?.serviceLabel || 'the server';
    return `Unable to reach ${target}. ${UNREACHABLE_SERVICE_MESSAGE}`;
  }

  if (error?.response) {
    const { status, statusText } = error.response;
    return `Failed to ${action}: server returned ${status}${statusText ? ` ${statusText}` : ''}`;
  }

  if (error?.message) {
    return `Failed to ${action}: ${error.message}`;
  }

  return `Failed to ${action}. Please try again.`;
};

export const showUnreachableServerToastIfNeeded = (error, { context, serviceLabel } = {}) => {
  if (!isLikelyUnreachableError(error)) return false;
  toast.error(
    getRequestFailureMessage(error, { context, serviceLabel }),
    UNREACHABLE_SERVER_TOAST_OPTIONS
  );
  return true;
};

export const showRequestFailureToast = (error, { context, serviceLabel } = {}) => {
  toast.error(
    getRequestFailureMessage(error, { context, serviceLabel }),
    isLikelyUnreachableError(error) ? UNREACHABLE_SERVER_TOAST_OPTIONS : { autoClose: 6000 }
  );
};
